export default [
  [`Размер`, `M`, `L`, `XL`],
  [`Российский размер`, `48`, `50`,`52` ],
  [`Полуобхват груди, см`, `47`, `53`, `55`],
  [`Длина изделия, см`, `67`, `69`, `73`],
  [`Длина рукава, см`, `77`, `81`, `83`]
];
